import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Zap, Settings, MessageCircle } from 'lucide-react';
export function ContactForm() {
  const [formData, setFormData] = useState({
    nombre: '',
    empresa: '',
    email: '',
    rol: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate API call
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSuccess(true);
      setFormData({
        nombre: '',
        empresa: '',
        email: '',
        rol: ''
      });
      // Reset success message after 5 seconds
      setTimeout(() => setIsSuccess(false), 5000);
    }, 1000);
  };
  return <section id="contacto" className="py-16 sm:py-24 bg-gray-50" data-id="element-35">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-36">
        <div className="text-center mb-10 sm:mb-12" data-id="element-37">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-4" data-id="element-38">
            Deja de perder horas en informes
          </h2>
          <p className="text-lg text-gray-600" data-id="element-39">
            Prueba InspectIA gratis. Sin tarjeta de crédito.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-white rounded-2xl border border-gray-200 shadow-sm p-6 sm:p-10" data-id="element-40">
          {isSuccess ? <div className="text-center py-12" data-id="element-41">
              <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-green-100 mb-6" data-id="element-42">
                <CheckCircle2 className="h-8 w-8 text-green-600" data-id="element-43" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-44">
                ¡Gracias por tu interés!
              </h3>
              <p className="text-gray-600" data-id="element-45">
                Hemos recibido tus datos. Nos pondremos en contacto contigo a la
                brevedad.
              </p>
              <button onClick={() => setIsSuccess(false)} className="mt-8 text-blue-600 font-medium hover:text-blue-800" data-id="element-46">
                Enviar otro mensaje
              </button>
            </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-47">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-48">
                <div data-id="element-49">
                  <label htmlFor="nombre" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-50">
                    Nombre completo *
                  </label>
                  <input type="text" id="nombre" name="nombre" required value={formData.nombre} onChange={handleChange} className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm border p-3" placeholder="Juan Pérez" data-id="element-51" />
                </div>
                <div data-id="element-52">
                  <label htmlFor="empresa" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-53">
                    Empresa *
                  </label>
                  <input type="text" id="empresa" name="empresa" required value={formData.empresa} onChange={handleChange} className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm border p-3" placeholder="Constructora XYZ" data-id="element-54" />
                </div>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-55">
                <div data-id="element-56">
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-57">
                    Email *
                  </label>
                  <input type="email" id="email" name="email" required value={formData.email} onChange={handleChange} className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm border p-3" placeholder="juan@empresa.com" data-id="element-58" />
                </div>
                <div data-id="element-59">
                  <label htmlFor="rol" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-60">
                    Rol
                  </label>
                  <select id="rol" name="rol" value={formData.rol} onChange={handleChange} className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm border p-3 bg-white" data-id="element-61">
                    <option value="" data-id="element-62">Selecciona un rol</option>
                    <option value="Arquitecto" data-id="element-63">Arquitecto</option>
                    <option value="ITO" data-id="element-64">ITO</option>
                    <option value="Ingeniero" data-id="element-65">Ingeniero</option>
                    <option value="Otro" data-id="element-66">Otro</option>
                  </select>
                </div>
              </div>

              <div className="pt-4" data-id="element-67">
                <button type="submit" disabled={isSubmitting} className={`w-full flex justify-center py-3.5 px-4 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors ${isSubmitting ? 'opacity-75 cursor-not-allowed' : ''}`} data-id="element-68">
                  {isSubmitting ? 'Enviando...' : 'Probar InspectIA'}
                </button>
                <p className="text-center mt-4 text-sm font-semibold text-blue-600" data-id="element-69">
                  Activa tu cuenta en menos de 24 horas.
                </p>
              </div>
            </form>}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="flex flex-col sm:flex-row flex-wrap justify-center gap-4 sm:gap-6 mt-8 sm:mt-12" data-id="element-70">
          <div className="flex items-center justify-center gap-2 text-sm text-gray-600" data-id="element-71">
            <Zap className="w-4 h-4 sm:w-5 sm:h-5 text-gray-400" data-id="element-72" />
            <span data-id="element-73">Sin tarjeta de crédito</span>
          </div>
          <div className="flex items-center justify-center gap-2 text-sm text-gray-600" data-id="element-74">
            <Settings className="w-4 h-4 sm:w-5 sm:h-5 text-gray-400" data-id="element-75" />
            <span data-id="element-76">Cancela cuando quieras</span>
          </div>
          <div className="flex items-center justify-center gap-2 text-sm text-gray-600" data-id="element-77">
            <MessageCircle className="w-4 h-4 sm:w-5 sm:h-5 text-gray-400" data-id="element-78" />
            <span data-id="element-79">Funciona con WhatsApp</span>
          </div>
        </motion.div>
      </div>
    </section>;
}